{
  "appCore": {
    "common": {
      "yes": "Sí",
      "no": "No",
      "errors": {
        "notEmpty": "Este campo no puede estar vacío"
      }
    },
    "footer": {
      "state": "términos de servicio",
      "policy": "política de privacidad"
    },
    "apps": {
      "popUp": {
        "privacyPolicy": {
          "header": "Un momento, una cosa más:",
          "text": "Declaro que he leído los {state} y {policy} y acepto sus términos.",
          "state": "términos de servicio",
          "policy": "política de privacidad",
          "decline": "Cancelar",
          "accept": "Sí, estoy de acuerdo"
        }
      },
      "event": {
        "common": {
          "underPictureText": "¡Muéstranos cómo te estás divirtiendo, nos reiremos mañana!",
          "back": "Atrás"
        },
        "mirrorWedding": {
          "sendText": "ENVIAR E IMPRIMIR",
          "sendingText": "ENVIANDO"
        },
        "wedding": {
          "sendText": "ENVIAR",
          "sendingText": "ENVIANDO",
          "1": {
            "sendText": "ENVIAR FOTOS/VIDEO"
          }
        },
        "gallery": {
          "header": "¡Galería del evento actual!",
          "name": "Galería",
          "button": "Galería de fotos",
          "subtext": "vista previa de fotos subidas",
          "moreFiles": "Más fotos",
          "changeView": "Cambiar vista",
          "loadedFiles": "Fotos cargadas",
          "noNewFiles": "No hay nuevos archivos para cargar. Las fotos en la galería se muestran en un orden aleatorio y no necesariamente aparecen al final."
        },
        "sender": {
          "errors": {
            "wrongFiles": "Puedes enviar hasta 20 fotos o videos con un tamaño total que no exceda 1 GB",
            "wrongFilesWithWish": "Puedes enviar un máximo de 1 foto con un tamaño total que no exceda 1 GB",
            "default": "Error en la transmisión del archivo",
            "notFiles": "No se seleccionaron archivos"
          },
          "infos": {
            "emptyWish": "Por favor, introduce tus deseos",
            "sendedFiles": "Todos los archivos enviados. Gracias :)",
            "sendedProcessing": "El video aparecerá en la galería después de ser procesado por el servidor",
            "fileUnsupported": "Foto cargada correctamente. Después de enviarla, la encontrarás en la galería.",
            "sendingProblem": {
              "sended": "Enviado",
              "from": "de",
              "files": "archivos",
              "checkFiles": "Verifica el archivo y envíalo de nuevo."
            }            
          },
          "button": "Enviar fotos/videos",
          "or": "o",
          "yourWishes": "Tus deseos"
        }
      },
      "rsvp": {
        "versions": {
          "1": {
            "invitationText": "tienen el honor de invitar",
            "placeText": "a la ceremonia de boda, que tendrá lugar",
            "yearAndHour": "a las",
            "in": "en",
            "0": {
              "placeText": "a la ceremonia de boda, que tendrá lugar"
            },
            "1": {
              "placeText": "ceremonia y recepción de boda, que tendrá lugar"
            },
            "2": {
              "partyText": "RECEPCIÓN DE BODA",
              "weddingPlace": "Ver la iglesia en el mapa",
              "partyPlace": "Ver el salón en el mapa"
            }
          },
          "2": {
            "wedding": "¡Habrá boda!",
            "year": "año",
            "hour": "a las",
            "weddingPath": "Haz clic para planificar tu ruta entre la iglesia y el salón de bodas:",
            "partyWelcome": "¡Estamos ansiosos por darte la bienvenida en nuestra boda!"
          }
        },
        "components": {
          "form": {
            "confirmArrival": "CONFIRMAR ASISTENCIA",
            "main": {
              "addAnotherGuest": "Agregar otro invitado",
              "addGuest": "Confirmar asistencia",
              "sendRsvp": "Enviar confirmación",
              "edit": "EDITAR",
              "name": "NOMBRE",
              "surname": "APELLIDO",
              "present": "Asistiré a la boda",
              "notPresent": "No asistiré a la boda",
              "notify": {
                "error": "Error en la transmisión de datos",
                "positive": "Datos enviados. Gracias :)",
                "notFilled": "No se han completado todos los campos obligatorios"
              }
            },
            "guest": {
              "guestData": "Introduce tu nombre y apellido:",
              "name": "Nombre",
              "surname": "Apellido",
              "willBePresent": "¿Asistirás a nuestra boda?",
              "save": "Guardar"
            },
            "verions": {
              "2": {
                "historyWish": "Nos gustaría que formaras parte de nuestra historia conjunta.",
                "dueToInfo": "Por favor, confirma tu asistencia antes del {dueToTime} completando el formulario a continuación.",
                "confirmArrival": "Confirmación de llegada",
                "guest": {
                  "guestData": "Introduce tu nombre y apellido:",
                  "willBePresent": "¿Confirmas tu asistencia?"
                }
              }
            }
          },
          "weddingWishes": {
            "title": "DESEOS DE BODA"
          },
          "clockWidget": {
            "title": "Tiempo restante para la boda",
            "clock": {
              "days": "días",
              "hours": "horas",
              "minutes": "minutos",
              "seconds": "segundos"
            }
          }
        }
      },
      "components": {
        "inputs": {
          "inputCheckboxTrueFalseSelect": {
            "selectLabel": "Selecciona una de las siguientes opciones:"
          }
        },
        "sender": {
          "sendLabel": "Agregar fotos o videos",
          "sendWithWishLabel": "Agregar foto y deseos",
          "from": "de",
          "processing": "Procesando",
          "notToGallery": "No mostrar en la galería"
        },
        "gks": {
          "findTable": "Encuentra tu mesa"
        }
      },
      "gks": {
        "header": "Plan de Asientos",
        "foundPlace": "Encuentra tu asiento...",
        "namePlaceholder": "Ingresa tu nombre",
        "personNotFound": "Persona No Encontrada",
        "samePersonFound": "Se encontraron más personas con un nombre similar, por favor continúa escribiendo...",
        "table": "Mesa",
        "footer": "...¡Y luego fiesta hasta el amanecer!"
      }
    }
  },
  "loremIpsum": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,"
}
